/*
    Patches bootstrap's tooltip behavior to prevent hiding the tooltip if the user hovers over the popup itself,
    such as the case when they need to click a link in the tooltip.

    Adapted from https://stackoverflow.com/questions/7703878/how-can-i-hold-twitter-bootstrap-popover-open-until-my-mouse-moves-into-it
 */
(function ($) {

    // Make sure the tooltip plugin exists (doesn't during unit test runs). 
    if ($.fn.tooltip == undefined) {
        return;
    }

    var originalLeave = $.fn.tooltip.Constructor.prototype._leave;
    $.fn.tooltip.Constructor.prototype._leave = function (event, context) {

        if (event == null) {
            return;
        }

        var dataKey = this.constructor.DATA_KEY
        var self = this

        context = context || $(event.currentTarget).data(dataKey)

        if (!context) {
            context = new this.constructor(
                event.currentTarget,
                this._getDelegateConfig()
            )
            $(event.currentTarget).data(dataKey, context)
        }

        originalLeave.call(this, event, context);

        if ($(event.currentTarget)) {
            var container = $(context.tip);

            container.one('mouseenter', function () {
                // clear the original timer so we keep it open
                clearTimeout(context._timeout)

                // monitor the popout so we can trigger close
                container.one('mouseleave', function () {
                    originalLeave.call(self, event, context);
                });
            })
        }
    };

}(jQuery));